import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TransportGoodsManager.html?raw';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import EntityStore from '../../moreCore/Tools/EntityStore';
import TiTransportGoodView from './TransportGoodView';
import TiFreightOccupationView from './FreightOccupation/FreightOccupationView';
import { TiEntities, TiInterfaces } from "./TiTypes";
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";


interface OffloadingEntry { label: string, value: number };
class TiTransportGoodManager extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private interactive: boolean = false;


    private sectionMessageCancellation: HTMLElement;
    private tgContainer: HTMLElement;
    private btnAddTransportGood: HTMLElement;
    private sectionFreightOccupation: HTMLElement;
    private freightOccupationContainer: HTMLElement;
    private controlContainer: HTMLElement;

    private registry: Array<{
        expander: MdsLax<InstanceType<typeof ExpandableSection>>,
        transportGoodID: string,
        removeBtn: HTMLElement;
        cancelBtn: HTMLElement;
    }>;

    private bookingData: TiEntities.BookingEntityData;

    private freightOccupationViewLDM: MdsLax<InstanceType<typeof TiFreightOccupationView>>;

    private tgStore: MdsLax<InstanceType<typeof EntityStore<TiEntities.TransportGoodEntity>>>;
    private blacklist: Array<string>;
    private SEDrequestData: Object;

    setReadonly(bReadOnly?: boolean) {
        this.interactive = bReadOnly === false;

        this.hideNode(this.btnAddTransportGood, !this.interactive);

        this.handleRemoveButtons();
    }

    enableFreightOccupation(bShowFreight?: boolean) {
        this.hideNode(this.sectionFreightOccupation, bShowFreight === false);
    }

    setupFromBooking(entity: TiEntities.BookingEntityData) {
        this.bookingData = entity;

        if (this.bookingData) {
            let now = new Date();
            let bookingDate: Date = (entity.dateStart) as any;
            this.setReadonly(this.bookingData.is_cancelled);// && now.valueOf() > bookingDate.valueOf());

            this.tgStore.setup(this.bookingData.transportGoods, "ID");

            this.drawData();
        } else {
            this.tgStore.empty();
            this.drawData();
            this.setReadonly();
        }
    }


    private handleRemoveButtons() {
        if (this.registry?.length) {
            for (let reg of this.registry) {
                if (reg.removeBtn) {
                    this.hideNode(reg.removeBtn, !this.interactive);
                } if (reg.cancelBtn && this.tgStore.isEntityExisting(reg.transportGoodID)) {
                    this.hideNode(reg.cancelBtn, !this.interactive);
                }
            }
        }
    }
    reset() {
        this.tgStore = new EntityStore();
        this.tgStore.on("change", lang.hitch(this, this._onChange_Store));

        this.blacklist = [];
    }
    addTransportGood(entity: TiEntities.TransportGoodEntity) {
        this.tgStore.addEntry(entity);
    }

    blacklistTransportGood(ID: string, bWhitelist?: boolean) {
        //console.debug(this.id + " blacklistTransportGood", ID);
        if (!ID) return;
        if (bWhitelist === true) {
            this.allowTransportGood(ID);
            return;
        }

        if (!this.blacklist) {
            this.blacklist = [];
        }

        if (this.blacklist.indexOf(ID) == -1) {
            this.blacklist.push(ID);
        }

        this.tgStore.deleteEntry(ID);
    }

    allowTransportGood(ID: string) {
        if (!ID) return;

        if (!this.blacklist) {
            this.blacklist = [];
        }

        let index = this.blacklist.indexOf(ID);
        while (index != -1) {
            this.blacklist.splice(index, 1);
            index = this.blacklist.indexOf(ID);
        }
    }

    setRequestData(data: Object) {
        this.SEDrequestData = lang.clone(data);
    }

    getTransportGoods(): Array<TiEntities.TransportGoodEntity> {
        return this.tgStore.getCurrentCompleteList();
    }
    getTransportGoodIDs(): Array<string> {
        return this.tgStore.getCurrentCompleteValueList();
    }

    private _saveData() {
        if (!this.interactive) return;


        let data: {
            removed: Array<string>,
            cancelled: Array<string>,
            new: Array<string>,
            bookingID: string
        } = {
            bookingID: this.bookingData?.ID,
            cancelled: [],
            new: [],
            removed: []
        };

        let diffData = this.tgStore.getDiffData();
        data.removed = diffData.deleted;
        data.new = diffData.new.map(function (tg) { return tg.ID });

        for (let ID of this.cancelledIDs) {
            let index = data.removed.indexOf(ID);
            if (index != -1) data.removed.splice(index, 1);

            data.cancelled.push(ID);
        }

        this.disableNode(this.controlContainer);

        this.emit("saving");

        this.StandbyStart();


        this.RequestManager.callfunction("Webtool_API_TransportIntermodal__SaveTransportGoods",
            data,
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError),
            true
        );
    }

    private _onSaveResponse(response: any) {
        this.StandbyStop();

        this.tgStore.commit();
        this.cancelledIDs = [];

        this.hideNode(this.controlContainer);
        this.disableNode(this.controlContainer, false);

        this.emit("saved");

        this.drawData();
    }

    private _onSaveError(error: more.requestErrorMessage) {
        alert(error.Message);
        this.StandbyStop();

        this.disableNode(this.controlContainer, false);
    }

    private _onClick_AddAdditionalTransportGood(evt: MouseEvent) {
        let list = this.tgStore.getCurrentCompleteValueList();
        if (this.blacklist) list = list.concat(this.blacklist);

        let data = {
            "excludedIDs": list,
            "bookingID": this.bookingData?.ID,
            "divisionID": this.bookingData?.divisionID
        };

        if (this.SEDrequestData) {
            data = { ...data, ...this.SEDrequestData };
        }

        this.showSelectEntityDialog(evt,
            "TiBooking_additionalTransportGoods",
            lang.hitch(this, this._onAdditionalTransportGoodResult),
            null,
            data
        );

        //let SED = new SelectEntityDialog();
        //SED.setup(
        //    this.translate("TiBooking_SelectAdditionalTransportGood"),
        //    lang.hitch(this, this._onAdditionalTransportGoodResult, SED),
        //    "Webtool_API_TransportIntermodal__GetAdditionalTransportGoodSEDResult",
        //    10,
        //    null,
        //    { maxSelect: 100, minSelect: 1 },
        //    "order_number",
        //    "ID",
        //    "tmp_displayname_web"
        //);

        //SED.displaySelectedItems(true);
        //SED.showSelectedTab = true;

    //    let selectedIds = [];
    //    selectedIds.push(this.transportGoodID);
    //    for (let tg of this.additionalTransportGoodsStore.getCurrentCompleteList()) {
    //        selectedIds.push(tg.ID);
    //    }

    //    SED.addRequestParameter("excludedIDs", selectedIds, true);
    //    SED.addRequestParameter("divisionID", this.divisionID, true);

    //    SED.show();
    }

    private _onAdditionalTransportGoodResult() {

        let selected = this.selectEntityDlg.getSelectedEntities();

        this.tgStore.addEntries(selected);
    }

    private drawData() {
        let list = this.tgStore.getCurrentCompleteList();

        this.hideNode(this.tgContainer, !list.length);

        this.UiModder.domConstruct.empty(this.tgContainer);

        this.registry = [];

        for (let tg of list) {
            let info = new TiTransportGoodView();
            info.setData(tg);

            let exp = new ExpandableSection();

            exp.setup(info.domNode, this.createFontawesomeIcon("fa-solid fa-boxes-packing", "&nbsp").outerHTML + tg.order_number, "small", true, true, false);

            exp.placeAt(this.tgContainer);

            let removeButton = this.UiModder.domConstruct.create("button", {
                className: "mds-button-base round tertiaryBG round hoverDark w3-hide",
                innerHTML: this.createFontawesomeIcon("fas fa-unlink").outerHTML,
                title: this.translate("TiBooking__Tooltip_RemoveTransportGood")
            });

             let cancelButton = this.UiModder.domConstruct.create("button", {
                className: "mds-button-base round deleteBtn round hoverDark w3-hide",
                 innerHTML: this.createFontawesomeIcon("fas fa-ban").outerHTML,
                 title: this.translate("TiBooking__Tooltip_CancelTransportGood")
            });

            on(removeButton, "click", lang.hitch(this, this._onClick_RemoveTransportGood, tg.ID));
            on(cancelButton, "click", lang.hitch(this, this._onClick_CancelTransportGood, tg.ID));

            exp.addRightHeadingContent(cancelButton, "right");
            exp.addRightHeadingContent(removeButton, "right");

            if (this.tgStore.isEntityNew(tg)) {
                exp.setMarking(ExpandableSectionMarkings.hasContent);
            } else {
                exp.setMarking(ExpandableSectionMarkings.default);
            }


            this.registry.push({
                expander: exp,
                transportGoodID: tg.ID,
                removeBtn: removeButton,
                cancelBtn: cancelButton
            });
        }

        this.drawFreight();
        this.handleRemoveButtons();

        this.hideNode(this.sectionMessageCancellation);
        if (this.tgStore.isDirty() && this.registry.length == 0) {
            this.hideNode(this.sectionMessageCancellation, false);
        }
    }
    private drawFreight() {
        this.freightOccupationViewLDM.removeCargo();
        this.freightOccupationViewLDM.removeSpace();
        this.hideNode(this.sectionFreightOccupation);

        if (this.bookingData && this.bookingData.logisticResource) {
            this.hideNode(this.sectionFreightOccupation, false);
            this.freightOccupationViewLDM.addAvailableSpace({
                internalName: this.bookingData.logisticResource.ID,
                value: this.bookingData.logisticResource.LDM,
                label: this.bookingData.logisticResource.identification
            });

        }

        let freightList = this.tgStore.getCurrentCompleteList();
        for (let tg of freightList) {
            let fct = null;
            let exp = this.getExpanderOfTransportGood(tg.ID);
            if (exp) {
                fct = lang.hitch(this, function (expander: MdsLax<InstanceType<typeof ExpandableSection>>) {
                    expander.toggleExpand(true);
                    expander.domNode.scrollIntoView();
                }, exp);
            }
            this.freightOccupationViewLDM.addCargo({
                internalName: tg.ID,
                value: tg.LDM,
                label: tg.order_number,
                clickFct: fct
            });
        }


        this.emit("exceeded", this.freightOccupationViewLDM.isExceededSpace());

    }
    getExpanderOfTransportGood(ID: string) {
        if (!this.registry?.length) return null;

        for (let reg of this.registry) {
            if (reg.transportGoodID == ID) {
                return reg.expander;
            }
        }

        return null;
    }
    private cancelledIDs: any = [];
    private _onClick_CancelTransportGood(ID: string) {
        if (!this.interactive) return;
        this.tgStore.deleteEntry(ID);

        this.cancelledIDs.push(ID);
    }
     private _onClick_RemoveTransportGood(ID: string) {
        if (!this.interactive) return;
        this.tgStore.deleteEntry(ID);
    }

    private _onClick_Submit(evt: MouseEvent) {
        if (this.interactive && this.tgStore.isDirty()) {
            if (this.tgStore.getCurrentCompleteList().length == 0) {
                let dlg = new GenericDialog();
                dlg.show(this.stringFormat(this.translate("TiBooking__Dlg_CancelLastTransportGood_Message"), this.bookingData.displayname),
                    this.stringFormat(this.translate("TiBooking__Dlg_CancelLastTransportGood_Title"), this.bookingData.displayname),
                    null,
                    "fas fa-triangle-exclamation",
                    "yesno",
                    lang.hitch(this, this._onConfirmCancelDlgResult),
                );

                return;
            } else {
                this._saveData();
            }
        }
    }

    private _onConfirmCancelDlgResult(result: number) {
        if (result >= 1) {
            this._saveData();
        }
    }
    private _onClick_Revert(evt: MouseEvent) {
        this.tgStore.reset();
        this.cancelledIDs = [];
        this.drawData();
        this.hideNode(this.controlContainer);
    }

    private _onChange_Store() {
        this.drawData();
        this.hideNode(this.controlContainer, !this.tgStore.isDirty());

        this.emit("change");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.reset();

        this.cancelledIDs = [];

        this.freightOccupationViewLDM = new TiFreightOccupationView();
        this.freightOccupationViewLDM.placeAt(this.freightOccupationContainer);
        this.freightOccupationViewLDM.valueSuffix = "m";
        this.freightOccupationViewLDM.valuePrefix = "";
        this.freightOccupationViewLDM.iconAvailableBar = "fa-solid fa-arrows-left-right-to-line";
        this.freightOccupationViewLDM.iconUsedBar = "fa-solid fa-boxes-packing";


        this.useStandbyManager = true;

        this.RequestManager.handleAs = "jsonWithDate";
        this.SEDconfigCallfunction = "Webtool_API_TransportIntermodal__GetSEDconfig"
        //this.inputTransportGood.addInlineButton(lang.hitch(this, this._onClick_OpenTransportGoodSED));
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);


    }

}

export default mdsWidget(TiTransportGoodManager);
